import './CreateModelModal.scss';

export { default } from './CreateModelModal';
